"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeplrEnigmaUtils = void 0;
/**
 * KeplrEnigmaUtils duplicates the public methods that are supported on secretjs's EnigmaUtils class.
 */
class KeplrEnigmaUtils {
    constructor(chainId, keplr) {
        this.chainId = chainId;
        this.keplr = keplr;
    }
    isNewApi() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.keplr.enigmaIsNewApi(this.chainId);
        });
    }
    getPubkey() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.keplr.getEnigmaPubKey(this.chainId);
        });
    }
    getTxEncryptionKey(nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.keplr.getEnigmaTxEncryptionKey(this.chainId, nonce);
        });
    }
    encrypt(contractCodeHash, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.keplr.enigmaEncrypt(this.chainId, contractCodeHash, msg);
        });
    }
    decrypt(ciphertext, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.keplr.enigmaDecrypt(this.chainId, ciphertext, nonce);
        });
    }
}
exports.KeplrEnigmaUtils = KeplrEnigmaUtils;
//# sourceMappingURL=enigma.js.map